/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_Body1Inputs */

const en_to_typescript_body1 = /** @type {(inputs: To_Typescript_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The generator infers types from the values in your sample, which is the only information a single JSON document carries. There is no schema to read, so what you get out is a faithful description of what you put in, not a description of what the API can return. That distinction is the whole story of using generated types well.`)
};

const ko_to_typescript_body1 = /** @type {(inputs: To_Typescript_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`생성기는 샘플의 값에서 타입을 추론합니다. 단일 JSON 문서가 담고 있는 정보는 그것뿐입니다. 읽을 스키마가 없으므로, 나오는 결과는 넣은 것에 대한 충실한 서술이지 API가 반환할 수 있는 것에 대한 서술이 아닙니다. 생성된 타입을 잘 쓰는 요령은 결국 이 구분에 달려 있습니다.`)
};

const ja_to_typescript_body1 = /** @type {(inputs: To_Typescript_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ジェネレータはサンプルの値から型を推論します。単一の JSON 文書が持つ情報はそれだけです。読むスキーマがないので、出てくるのは入れたものの忠実な記述であって、API が返しうるものの記述ではありません。生成された型をうまく使う勘所は、結局この区別にあります。`)
};

/**
* | output |
* | --- |
* | "The generator infers types from the values in your sample, which is the only information a single JSON document carries. There is no schema to read, so what ..." |
*
* @param {To_Typescript_Body1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_body1 = /** @type {((inputs?: To_Typescript_Body1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_Body1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_body1(inputs)
	if (locale === "ko") return ko_to_typescript_body1(inputs)
	return ja_to_typescript_body1(inputs)
});